// removed by extract-text-webpack-plugin
module.exports = {"att-logo":"LogoLoader__att-logo","attLogo":"LogoLoader__att-logo"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Loader/components/LogoLoader/LogoLoader.mobile.css
// module id = 1170
// module chunks = 8